import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TeamHubTheme from './theme/teamhub_theme';
import TeamHub from './containers/teamhub';
import createStore from './services/create_store';
import { loadUser } from './actions/auth';
import ChromecastManager from './services/chromecast/chromecast_manager';
import './style.scss';

const store = createStore();

function initUser() {
  return dispatch => (dispatch(loadUser()));
}

const renderApp = () => render((
  <AppContainer>
    <Provider store={store}>
      <MuiThemeProvider muiTheme={TeamHubTheme}>
        <TeamHub />
      </MuiThemeProvider>
    </Provider>
  </AppContainer>
), document.getElementById('root'));

function load() {
  store.dispatch(initUser()).then(renderApp);
}


if (module.hot) {
  module.hot.accept('./components/teamhub/teamhub', load);
}

load();

ChromecastManager.init();



// WEBPACK FOOTER //
// ./src/index.jsx